import { createFileRoute } from '@tanstack/react-router';
import { CarrierShipmentsTab } from '@/features/carriers/shipments/carrier-shipments-tab';

// S15 · The carrier's shipments (07 §4).
export const Route = createFileRoute('/_app/carriers/$code/shipments')({
  component: CarrierShipmentsTab,
});
